import { API_URL } from "../config/connect";

/**
 * GET /api/v1/rubrics
 * Жауап: массив рубрик. Әр рубрика: rubric_id, rubric_name, categories.
 * categories — массив: category_id, name_ru, name_kz, name_en, name_ch, subcategories.
 * Файл жоқ/бұзылған болса жауап: [].
 */
export async function getRubrics() {
    try {
        const response = await fetch(`${API_URL}/api/v1/rubrics`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error("Error fetching rubrics:", error);
        return [];
    }
}
